import { defineComponent as _defineComponent } from 'vue';
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-dc00671e"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "flex items-center"
};
export default /*#__PURE__*/_defineComponent({
  __name: 'saveBtn',
  props: {
    loading: {
      type: Boolean,
      default: false
    }
  },
  emits: ['cancel', 'save'],
  setup(__props, {
    emit: __emit
  }) {
    const emits = __emit;
    const handleClick = type => {
      if (type === 'cancel') {
        emits('cancel', type);
      } else {
        emits('save', type);
      }
    };
    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_button, {
        class: "save",
        onClick: _cache[0] || (_cache[0] = $event => handleClick('cancel'))
      }, {
        default: _withCtx(() => [_createTextVNode("取消")]),
        _: 1
      }), _createVNode(_component_el_button, {
        class: "save marginL10",
        type: "primary",
        onClick: _cache[1] || (_cache[1] = $event => handleClick('save')),
        loading: __props.loading
      }, {
        default: _withCtx(() => [_createTextVNode("保存")]),
        _: 1
      }, 8, ["loading"])]);
    };
  }
});